// function validateEmail(email){
//     let email_string = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//     if(email.match(email_string)){
//         return true;
//     }else {
//         return false;
//     }
//
// }
// function validatePhone(phone){
//     let letters =/[a-zA-Z\/\\\*\%\$\|\#\@\'\"\:\;\&\?\.\,\<\>]/g;
//     if(phone.match(letters)){
//         return false;
//     }
//     else{
//         return true ;
//     }
// }
function customValidate(str, regExpression) {
  if (str.match(regExpression) != null) {
    return true;
  } else {
    return false;
  }
}
function formValidation() {
  let forms = document.querySelectorAll(".js-contact-form-validation form");
  if (!forms.length > 0) {
    return;
  }
  forms.forEach(function (form) {
    let button = form.querySelector(
      'button[type="submit"]:not([name="decline"]',
    );
    button.addEventListener("click", function (e) {
      e.preventDefault();
      let validation = true;
      let requiredFields = form.querySelectorAll(
        'input[required]:not([type="checkbox"])',
      );
      let requiredEmail = form.querySelectorAll('input[type="email"]');
      let phone = form.querySelectorAll('input[type="tel"]');
      let customValidation = form.querySelectorAll(
        'input[data-custom-validation][type="text"]',
      );
      let requiredTextarea = form.querySelectorAll("textarea[required]");
      let requiredCheckbox = form.querySelectorAll(
        'input[type="checkbox"][required]',
      );
      let requiredSelect = form.querySelectorAll("select[required]");
      customValidation.forEach(function (field) {
        let fieldValue = field.value.trim();
        let fieldRegExp = field.dataset.customValidation;
        if (fieldValue !== "" && fieldRegExp) {
          if (customValidate(field.value, fieldRegExp) != true) {
            validation = false;
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.add("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field.closest(".wrapper-inputs__item").classList.add("hasError");
              if (
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message")
              ) {
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message").innerHTML =
                  window.errors.custom_validation_error;
              }
            }
          } else {
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.remove("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field
                .closest(".wrapper-inputs__item")
                .classList.remove("hasError");
            }
          }
        }
      });
      requiredFields.forEach(function (field) {
        let fieldValue = field.value.trim();
        if (fieldValue === "") {
          validation = false;
          if (field.closest(".form-group-input")) {
            field.closest(".form-group-input").classList.add("hasError");
          }
          if (field.closest(".wrapper-inputs__item")) {
            field.closest(".wrapper-inputs__item").classList.add("hasError");
            if (
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message")
            ) {
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message").innerHTML =
                window.errors.required_error;
            }
          }
        } else {
          if (!field.hasAttribute("data-custom-validation")) {
            if (field.closest(".form-group-input")) {
              if (
                !field
                  .closest(".form-group-input")
                  .classList.contains("double-input")
              ) {
                field.closest(".form-group-input").classList.remove("hasError");
              } else {
                if (
                  field.closest(".form-group-input").firstElementChild ==
                  field.closest(".form-group-input-wrapper")
                ) {
                  field
                    .closest(".form-group-input")
                    .classList.remove("hasError");
                }
              }
            }
            if (field.closest(".wrapper-inputs__item")) {
              if (
                !field
                  .closest(".form-group-input")
                  .classList.contains("double-input")
              ) {
                field
                  .closest(".wrapper-inputs__item")
                  .classList.remove("hasError");
              } else {
                if (
                  field.closest(".form-group-input").firstElementChild ==
                  field.closest(".form-group-input-wrapper")
                ) {
                  field
                    .closest(".wrapper-inputs__item")
                    .classList.remove("hasError");
                }
              }
            }
          }
        }
      });
      requiredEmail.forEach(function (field) {
        let fieldValue = field.value.trim();
        if (fieldValue === "") {
          validation = false;
          if (field.closest(".form-group-input")) {
            field.closest(".form-group-input").classList.add("hasError");
          }
          if (field.closest(".wrapper-inputs__item")) {
            field.closest(".wrapper-inputs__item").classList.add("hasError");
            if (
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message")
            ) {
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message").innerHTML =
                window.errors.required_error;
            }
          }
        } else {
          if (validateEmail(field.value) != true) {
            validation = false;
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.add("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field.closest(".wrapper-inputs__item").classList.add("hasError");
              if (
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message")
              ) {
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message").innerHTML =
                  window.errors.email_error;
              }
            }
          } else {
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.remove("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field
                .closest(".wrapper-inputs__item")
                .classList.remove("hasError");
            }
          }
        }
      });
      phone.forEach(function (field) {
        let fieldValue = field.value.trim();
        if (fieldValue !== "") {
          if (validatePhone(field.value) != true) {
            validation = false;
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.add("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field.closest(".wrapper-inputs__item").classList.add("hasError");
              if (
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message")
              ) {
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message").innerHTML =
                  window.errors.phone_error;
              }
            }
          } else {
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.remove("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field
                .closest(".wrapper-inputs__item")
                .classList.remove("hasError");
            }
          }
        } else {
          if (field.hasAttribute("required")) {
            validation = false;
            if (field.closest(".form-group-input")) {
              field.closest(".form-group-input").classList.add("hasError");
            }
            if (field.closest(".wrapper-inputs__item")) {
              field.closest(".wrapper-inputs__item").classList.add("hasError");
              if (
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message")
              ) {
                field
                  .closest(".wrapper-inputs__item")
                  .querySelector(".error-message").innerHTML =
                  window.errors.required_error;
              }
            }
          }
        }
      });
      requiredTextarea.forEach(function (field) {
        let fieldValue = field.value.trim();
        if (fieldValue === "") {
          validation = false;
          if (field.closest(".form-group-input")) {
            field.closest(".form-group-input").classList.add("hasError");
          }
          if (field.closest(".wrapper-inputs__item")) {
            field.closest(".wrapper-inputs__item").classList.add("hasError");
            if (
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message")
            ) {
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message").innerHTML =
                window.errors.required_error;
            }
          }
        } else {
          if (field.closest(".form-group-input")) {
            field.closest(".form-group-input").classList.remove("hasError");
          }
          if (field.closest(".wrapper-inputs__item")) {
            field.closest(".wrapper-inputs__item").classList.remove("hasError");
          }
        }
      });
      requiredCheckbox.forEach(function (field) {
        let fieldValue = field.value.trim();
        if (field.checked === false) {
          validation = false;
          if (field.closest(".wrapper-inputs__item")) {
            field
              .closest(".wrapper-inputs__item")
              .classList.add("hasErrorСheckbox");
          }
        } else {
          if (field.closest(".wrapper-inputs__item")) {
            field
              .closest(".wrapper-inputs__item")
              .classList.remove("hasErrorСheckbox");
          }
        }
      });
      requiredSelect.forEach(function (field) {
        let fieldValue = field.value.trim();
        if (fieldValue === "") {
          validation = false;
          if (field.closest(".form-group-input")) {
            field.closest(".form-group-input").classList.add("hasError");
          }
          if (field.closest(".wrapper-inputs__item")) {
            field.closest(".wrapper-inputs__item").classList.add("hasError");
            if (
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message")
            ) {
              field
                .closest(".wrapper-inputs__item")
                .querySelector(".error-message").innerHTML =
                window.errors.required_error;
            }
          }
        } else {
          if (field.closest(".form-group-input")) {
            field.closest(".form-group-input").classList.remove("hasError");
          }
          if (field.closest(".wrapper-inputs__item")) {
            field.closest(".wrapper-inputs__item").classList.remove("hasError");
          }
        }
      });
      console.log("form validation:" + validation);
      if (validation) {
        if (form.classList.contains("js-newsletter-subscribe")) {
          newsletterSubscribe(form);
        } else {
          form.submit();
        }
        return form;
      } else {
        if (form.querySelector(".wrapper-inputs__item.hasError")) {
          form.querySelector(".wrapper-inputs__item.hasError").scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest",
          });
        }
      }
    });
  });
  if (forms.length > 0) {
    // document.body.addEventListener("input", function (event) {
    //     if(event.target.closest('.form-group-input')){
    //         if (event.target.closest('.form-group-input').classList.contains("hasError")) {
    //             event.target.closest('.form-group-input').classList.remove("hasError");
    //         }
    //         if (event.target.closest('.wrapper-inputs__item').classList.contains("hasError")) {
    //             event.target.closest('.wrapper-inputs__item').classList.remove("hasError");
    //         }
    //     }
    // });
  }
}
formValidation();

function newsletterSubscribe(form) {
  let currentEmail = form.querySelector("[data-professional-email]");
  let currentFirstName = form.querySelector("[data-professional-first-name]");
  let currentLastName = form.querySelector("[data-professional-last-name]");
  let currentCompanyName = form.querySelector(
    "[data-professional-company-name]",
  );
  let currentCompanyType = form.querySelector(
    "[data-professional-company-type]",
  );
  let currentPhone = form.querySelector("[data-professional-phone]");
  let customTags =
    form.querySelector('input[name="tags"]')?.value || "newsletter";
  let requestDataStr = "";
  let event = new Event("input");

  let shopifyProfessionalForm = document.querySelector(
    '[data-forms-id="forms-root-158457"] shopify-forms-embed',
  );

  if (currentEmail) {
    requestDataStr += `EMAIL=${currentEmail.value}`;
    if (currentFirstName) {
      requestDataStr += `&FNAME=${currentFirstName.value}`;
    }
    if (currentLastName) {
      requestDataStr += `&LNAME=${currentLastName.value}`;
    }
    if (currentCompanyName) {
      requestDataStr += `&MMERGE6=${currentCompanyName.value}`;
    }
    if (currentCompanyType) {
      requestDataStr += `&MMERGE7=${currentCompanyType.value}`;
    }
    if (currentPhone) {
      requestDataStr += `&PHONE=${currentPhone.value}`;
    }
    requestDataStr += `&MMERGE9=${encodeURIComponent(customTags)}&b_e2953e97c82b5390683028c78_25cbd195e3=`;
    sendMailchimp(
      "https://klusloods.us18.list-manage.com/subscribe/post-json?u=e2953e97c82b5390683028c78&id=25cbd195e3&f_id=00a3f7e0f0&c=?",
      requestDataStr,
      form,
    );
    if (shopifyProfessionalForm) {
      if (
        shopifyProfessionalForm.shadowRoot.querySelector('input[id="email"]') &&
        currentEmail
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="email"]',
        ).value = currentEmail.value;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="email"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="first_name"]',
        ) &&
        currentFirstName
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="first_name"]',
        ).value = currentFirstName.value;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="first_name"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="last_name"]',
        ) &&
        currentLastName
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="last_name"]',
        ).value = currentLastName.value;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="last_name"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_name"]',
        ) &&
        currentCompanyName
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_name"]',
        ).value = currentCompanyName.value;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="custom#company_name"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_type"]',
        ) &&
        currentCompanyType
      ) {
        shopifyProfessionalForm.shadowRoot.querySelector(
          'input[id="custom#company_type"]',
        ).value = currentCompanyType.value;
        shopifyProfessionalForm.shadowRoot
          .querySelector('input[id="custom#company_type"]')
          .dispatchEvent(event);
      }
      if (
        shopifyProfessionalForm.shadowRoot.querySelector(
          'button[type="submit"]',
        )
      ) {
        shopifyProfessionalForm.shadowRoot
          .querySelector('button[type="submit"]')
          .click();
      }
    }
  }
}
// The theme does not load jQuery, so the JSONP request is made without it.
function sendMailchimpJsonp(options) {
  const callback =
    "mailchimpCallback" + Date.now() + Math.random().toString(36).slice(2);
  const script = document.createElement("script");
  const cleanup = () => {
    delete window[callback];
    script.remove();
  };
  window[callback] = (res) => {
    cleanup();
    options.success(res);
  };
  script.onerror = (error) => {
    cleanup();
    options.error(error);
  };
  // c is the callback parameter that makes MailChimp return a JSONP response
  script.src = options.url.replace("c=?", "c=" + callback) + "&" + options.data;
  document.body.appendChild(script);
}
function sendMailchimp(url, data, form) {
  console.log(data);
  sendMailchimpJsonp({
    url: url,
    data: data,
    error: (error) => {
      console.log(error);
      console.log("Error", error);
    },
    success: (res) => {
      console.log(res.result);
      console.log(res.msg);
      if (res.result == "success") {
        form.submit();
      }
    },
  });
}
